export const queryKeys = {
    ORGANIZATION_ADMIN: "organization_admin",
    SUBSIDIARY: "subsidiary"
}